import cn from 'clsx'

import React from 'react'
export type Props = {
  active?: boolean
  children?: React.ReactNode
  className?: string
  tabIndex?: number
}

const TabContent = (props: Props): React.ReactElement<'section'> => {
  const { className = '', children, active = false } = props
  const rootClass = cn(
    'Tab',
    {
      Tab_Active: active,
    },
    className,
  )
  return <section className={rootClass}>{children}</section>
}

export default TabContent
